import { ajax } from 'cadenza/api-client/api';

interface OtherLayerSelectionConfig {
  sourceLayerId: string;
  targetLayerId: string;
  distance: number;
  mapSrs: string;
  mapScale: number;
}

/* @see net/disy/gis/gisterm/web/map/layer/feature/select/other/layer/rest/SelectFromOtherLayerEndpointController.java */
export function selectOtherLayerApi ({
  sourceLayerId,
  targetLayerId,
  distance,
  mapSrs,
  mapScale
}: OtherLayerSelectionConfig) {
  const params = new URLSearchParams({
    sourceLayerId,
    distance: String(distance),
    srsCode: mapSrs,
    mapScale: String(mapScale)
  });
  return ajax(`/layers/${targetLayerId}/selection?${params}`, {
    type: 'POST'
  });
}
